import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';

import { HeaderComponent } from './header/header.component';
import { MenuComponent } from './menu/menu.component';

import { AccountCardComponent } from './account-card/account-card.component';
import { AccrualsComponent } from './accruals/accruals.component';
import { DocumentsComponent } from './documents/documents.component';
import { HistoryComponent } from './history/history.component';
import { MetersComponent } from './meters/meters.component';
import { PaymentComponent } from './payment/payment.component';
import { NumeralPluralsPipe } from './pipes';
import { FooterComponent } from './footer/footer.component';

@NgModule({
  declarations: [
    AccountCardComponent,
    AccrualsComponent,
    DocumentsComponent,
    HeaderComponent,
    HistoryComponent,
    MenuComponent,
    MetersComponent,
    PaymentComponent,
    NumeralPluralsPipe,
    FooterComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    MatButtonModule,
    MatCheckboxModule,
    MatDialogModule,
    MatDividerModule,
    MatIconModule,
    MatInputModule,
    MatFormFieldModule,
    MatMenuModule,
    MatSelectModule,
    MatSnackBarModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    RouterModule,
  ],
  exports: [
    FormsModule,
    MatButtonModule,
    MatCheckboxModule,
    MatDialogModule,
    MatDividerModule,
    MatIconModule,
    MatInputModule,
    MatMenuModule,
    MatFormFieldModule,
    MatSelectModule,
    MatSnackBarModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    ReactiveFormsModule,

    AccountCardComponent,
    AccrualsComponent,
    DocumentsComponent,
    HeaderComponent,
    HistoryComponent,
    MenuComponent,
    MetersComponent,
    PaymentComponent,
    NumeralPluralsPipe,
    FooterComponent,
  ],
  providers: [NumeralPluralsPipe],
})
export class SharedModule {}
